<template>
  <!-- 상환내역 있는 경우 -->
  <div v-if="paging.totalCount > 0" class="table-container">
    <div class="scroll-wrapper" @scroll="scrollLeft = $event.target.scrollLeft">
      <table class="mb-1" :class="{ scrolled }">
        <thead class="text-center">
          <td>상환일</td>
          <td>원금</td>
          <td>이자</td>
          <td>수수료</td>
          <td>잔액</td>
        </thead>
        <tr v-for="(item, index) in paging.data" :key="index">
          <td class="text-center">{{ $moment(item.date).format() }}</td>
          <td class="text-right">{{ commaFormat(item.principal) }}</td>
          <td class="text-right">{{ commaFormat(item.interest + item.overdueInterest) }}</td>
          <td class="text-right">{{ commaFormat(item.fee) }}</td>
          <td class="text-right">{{ commaFormat(item.loanBalance) }}</td>
        </tr>
      </table>
    </div>

    <v-row class="align-center">
      <v-col cols="5" md="3" lg="2">
        <span class="font--m-7">{{ paging.pageInfoLabel }}</span>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="4" md="3" lg="2" class="d-flex justify-end">
        <v-btn small icon color="#757575" :disabled="paging.previousPageAvailable" @click="page--">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn small icon color="#757575" :disabled="paging.nextPageAvailable" @click="page++">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>

  <!-- 상환내역 없는 경우 -->
  <table v-else class="no-data-table">
    <thead class="text-center">
      <td>상환일</td>
      <td>원금</td>
      <td>이자</td>
      <td>수수료</td>
      <td>잔액</td>
    </thead>
    <tr>
      <td colspan="5">
        <v-layout justify-center fill-height align-center column>
          <v-btn outlined fab disabled x-small>
            <v-icon size="20">mdi-exclamation</v-icon>
          </v-btn>
          <p class="mt-2 color--nice-grey">상환 내역이 존재하지 않습니다.</p>
        </v-layout>
      </td>
    </tr>
  </table>
</template>

<script>
import { mapActions } from 'vuex'
import { commaFormat } from '@/filter/number'
export default {
  props: {
    loan: {
      required: true,
    },
  },
  data() {
    return {
      page: 1,
      size: 20,

      repayments: [],
      uuid: null,
      scrollLeft: 0,
    }
  },
  computed: {
    /**
     * @param this.page
     * @param this.size
     */
    paging() {
      // 전체 데이터 개수
      const totalCount = this.sortRepayments.length

      // 총 페이지 수
      const totalPage = Math.ceil(totalCount / this.size)

      // 현재 페이지의 시작 인덱스와 끝 인덱스 계산
      const startIndex = (this.page - 1) * this.size
      const endIndex = Math.min(startIndex + this.size - 1, totalCount - 1)

      // 현재 페이지의 데이터 추출
      const currentPageData = this.sortRepayments.slice(startIndex, endIndex + 1)

      // 페이징 정보 생성
      const pageInfoLabel = `총 ${totalCount}건 중 ${startIndex + 1}-${endIndex + 1} 표시`

      return {
        previousPageAvailable: 1 === this.page,
        nextPageAvailable: totalPage <= this.page,
        page: this.page, // 현재페이지
        size: this.size, // 페이지당 보여줄 갯수
        startIndex, // 시작 rowNum
        totalCount, // 게시판 총 컨텐츠 숫자
        totalPage,
        pageInfoLabel, // 총 10건 중 1-5 표시
        data: currentPageData,
      }
    },
    sortRepayments() {
      return [...this.repayments]
        .sort(function (a, b) {
          if (a.date > b.date) {
            return 1
          }
          if (a.date < b.date) {
            return -1
          }
          // a must be equal to b
          return 0
        })
        .splice(1) // 최초의 0번째 인덱스가 대출 실행정보를 가지고 있는거 같아서 삭제
    },
    scrolled() {
      return this.scrollLeft != 0
    },
  },
  created() {
    if (typeof this.loan === 'string') {
      this.uuid = this.loan
    } else {
      this.uuid = this.loan.uuid
    }
  },
  watch: {
    uuid: {
      async handler(v) {
        this.repayments = await this.getLoansRepayments(v)
      },
    },
  },
  methods: {
    ...mapActions('loan', ['getLoansRepayments']),
    commaFormat,
  },
}
</script>

<style lang="scss" scoped>
table.no-data-table {
  color: #333;
  width: 100%;
  border-collapse: collapse;
  font-weight: 700;

  thead td {
    background-color: #eee;
    color: #757575;
    border: 1px solid #aeaeae;
    padding: 0 6px;
    font-size: 13px;
  }

  tr td {
    border-bottom: 1px solid #eee;
    padding: 15px 0;
    p {
      margin-bottom: 0;
    }
  }
}

.table-container {
  position: relative;

  .scroll-wrapper {
    position: relative;
    overflow-x: auto;

    &::-webkit-scrollbar {
      height: 3px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #aeaeae;
    }

    table {
      color: #333;
      min-width: 425px;
      width: 100%;
      border-collapse: collapse;
      font-weight: 700;

      thead td {
        background-color: #eee;
        color: #757575;
      }
      tr:nth-of-type(odd) td {
        background-color: white;
      }
      tr:nth-of-type(even) td {
        background-color: #f7f7f7;
      }

      &.scrolled td:nth-of-type(1),
      &.scrolled th:nth-of-type(1) {
        border-left: none;
        border-right: none;

        &::before {
          border-left: 1px solid #aeaeae;
          border-right: 1px solid #aeaeae;
        }

        &::after {
          position: absolute;
          content: '';
          width: 30px;
          height: 100%;
          right: -30px;
          z-index: 4;
          transition: box-shadow 0.3s;
          pointer-events: none;
          box-shadow: inset 10px 0 8px -8px rgba(5, 5, 5, 0.16);
        }
      }

      td:nth-of-type(1),
      th:nth-of-type(1) {
        position: sticky;
        left: 0;
        border: 1px solid #aeaeae;
        width: 100px;

        &::before {
          position: absolute;
          top: 0;
          bottom: 0;
          z-index: 4;
          width: 100%;
          content: '';
          right: 0;
        }
      }

      td {
        border: 1px solid #aeaeae;
        padding: 0 6px;
        font-size: 13px;
      }
    }
  }
}
</style>
